import React from 'react';
import cn from 'classnames/bind';

import { getImageUrlBySize } from '@/shared/lib/images';

import { SessionStopImageProps } from './SessionStop.types';
import styles from './SessionStop.module.css';

const cx = cn.bind(styles);

const CHANNEL_CARD_URL_SIZE = '720x720';

export const SessionStopImage: React.FC<SessionStopImageProps> = ({ title, posterUrl }) => (
    <img
        title={title}
        className={cx('image')}
        src={getImageUrlBySize(posterUrl, CHANNEL_CARD_URL_SIZE)}
        alt={title}
    />
);
